"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _DocumentHead = _interopRequireDefault(require("ecosystem-marketplace-core/components/portals/DocumentHead"));

var _PrerenderReady = _interopRequireDefault(require("ecosystem-marketplace-core/components/prerender/PrerenderReady"));

var _auth = require("../selectors/auth");

var _params = require("../utils/params");

var withCategoryParamValidation = function withCategoryParamValidation(RouteComponent) {
  return function (props) {
    var params = props.match.params;
    var category = params.category,
        superCategory = params.superCategory;

    if (category && !(0, _params.hasValidCategoryParam)(params)) {
      return _react.default.createElement(_react.Fragment, null, _react.default.createElement(_reactRouterDom.Redirect, {
        to: "/" + superCategory
      }), _react.default.createElement(_auth.PublicOnly, null, _react.default.createElement(_DocumentHead.default, null, _react.default.createElement(_PrerenderReady.default, {
        statusCode: 404
      }))));
    }

    return _react.default.createElement(RouteComponent, props);
  };
};

var _default = withCategoryParamValidation;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/decorators/withCategoryParamValidation.js
// module id = 666
// module chunks = 209 210 211 212